import * as stylingConstants from './styling/constants';
import * as stylingHelpers from './styling/helpers';
import { standard, blue } from './themes';

// Styling
export { stylingConstants, stylingHelpers };

export const Theme = {
  base: standard,
  challenge20: blue,
};
